import React from 'react'
const SvgProvide7 = props => (
  <svg data-name='\u56FE\u5C42 2' viewBox='0 0 47.81 48' {...props}>
    <g data-name='\u56FE\u5C42 1'>
      <path
        d='M24 48C10.77 48 0 37.23 0 24S10.77 0 24 0c11.52 0 21.44 8.2 23.58 19.5l-1.96.37C43.66 9.51 34.57 1.99 24.01 1.99 11.87 2 2 11.87 2 24s9.87 22 22 22c11.08 0 20.46-8.27 21.83-19.25l1.98.25C46.32 38.97 36.08 48 24 48z'
        fill='#334966'
      />
      <path
        d='M31.91 15v-3h-2v3h-12v-3h-2v3h-4v21h24.01V15h-4zm2 19h-20V22h20.01v12zm0-14h-20v-3h20.01v3z'
        fill='#fd5c1f'
      />
    </g>
  </svg>
)
export default SvgProvide7
